import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Toolbar from '@mui/material/Toolbar';
import { useShellStore } from '@store/shell';
import { getPathnameId, isSettingsPath, logOut, pushPath } from '@utils';
import { useCallback, useMemo } from 'react';
import Styled from './AppBar.styled';
import { Tooltip } from '@ui/tooltip';
import { IconButton } from '@ui/buttons';
import { SignOutIcon } from '@ui/icons';

function AppBar() {
  const shellPathname = useShellStore((state) => state.pathname);
  const browserPathname = useShellStore((state) => state.browserPathname);
  const homeTo = shellPathname === '' ? '/' : shellPathname;

  const { isHomeActive, isSettingsActive } = useMemo(() => {
    const isSettings = isSettingsPath(browserPathname);
    const isHome =
      !getPathnameId() &&
      (browserPathname === '/' ||
        (shellPathname !== '' && browserPathname === shellPathname));
    return { isHomeActive: isHome, isSettingsActive: isSettings };
  }, [browserPathname, shellPathname]);

  const goHome = useCallback(() => {
    pushPath(homeTo);
  }, [homeTo]);

  const goSettings = useCallback(() => {
    pushPath('/settings');
  }, []);

  const isActiveRoute = useCallback(
    (path: string) => {
      if (path === '/settings') {
        return isSettingsActive;
      }
      if (path === '/') {
        return isHomeActive;
      }
      return browserPathname === path;
    },
    [isHomeActive, isSettingsActive, browserPathname]
  );

  const handleLogOut = useCallback(() => {
    logOut();
  }, []);

  return (
    <Styled.AppBar color="transparent" elevation={0} position="static">
      <Toolbar disableGutters sx={{ gap: 2, px: 2 }}>
        <Styled.BrandTitle onClick={goHome}>Octopus</Styled.BrandTitle>
        <Box flexGrow={1} />
        <Stack direction="row" spacing={1}>
          <Styled.NavButton active={isActiveRoute('/')} onClick={goHome}>
            Home
          </Styled.NavButton>
          <Styled.NavButton
            active={isActiveRoute('/settings')}
            onClick={goSettings}>
            Settings
          </Styled.NavButton>
          <Tooltip content="Log out">
            <IconButton
              color="inherit"
              onClick={handleLogOut}
              size="medium"
              icon={<SignOutIcon width={20} height={20} />}
              variant={'text'}
            />
          </Tooltip>
        </Stack>
      </Toolbar>
    </Styled.AppBar>
  );
}

export default AppBar;
